export default function RewardsSection() {
  return (
    <section id="rewards" className="py-32 px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <h2 
            className="text-6xl font-black text-gray-900 leading-tight"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            후원자만을 위한<br />
            <span className="text-amber-600">특별한 리워드</span>
          </h2>
        </div>
        
        <div className="grid grid-cols-3 gap-8">
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all border border-gray-200 group cursor-pointer">
            <div className="h-80 bg-gray-50 flex items-center justify-center p-8">
              <img
                src="https://public.readdy.ai/ai/img_res/8b6da45ae4b4763c3cc1f8c20702ecad.jpg"
                alt="디지털 포스터"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform"
              />
            </div>
            
            <div className="p-6 space-y-3">
              <h3 className="text-xl font-bold text-gray-900" style={{ fontFamily: "'Noto Serif KR', serif" }}>
                디지털 포스터
              </h3>
              <p className="text-2xl font-black text-amber-600">₩10,000</p>
              <p className="text-sm text-gray-600 leading-relaxed">
                고해상도 디지털 포스터 + 엔딩 크레딧 후원자 명단 등재
              </p>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all border border-gray-200 group cursor-pointer">
            <div className="h-80 bg-gray-50 flex items-center justify-center p-8">
              <img
                src="https://readdy.ai/api/search-image?query=premium%20hardcover%20movie%20script%20book%20with%20leather%20texture%20and%20golden%20embossed%20title%20on%20clean%20white%20background%20professional%20product%20photography%20with%20elegant%20presentation%20and%20soft%20lighting&width=600&height=800&seq=reward002&orientation=portrait"
                alt="한정판 대본집"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform"
              />
            </div>
            
            <div className="p-6 space-y-3">
              <h3 className="text-xl font-bold text-gray-900" style={{ fontFamily: "'Noto Serif KR', serif" }}>
                한정판 대본집
              </h3>
              <p className="text-2xl font-black text-amber-600">₩50,000</p>
              <p className="text-sm text-gray-600 leading-relaxed">
                감독 사인 대본집 + VIP 시사회 초대권 2매
              </p>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all border border-gray-200 group cursor-pointer">
            <div className="h-80 bg-gray-50 flex items-center justify-center p-8">
              <img
                src="https://readdy.ai/api/search-image?query=vintage%20film%20reel%20and%20clapperboard%20with%20golden%20accents%20on%20clean%20white%20background%20cinematic%20equipment%20product%20photography%20with%20professional%20lighting%20and%20elegant%20composition&width=600&height=800&seq=reward003&orientation=portrait"
                alt="프로듀서 크레딧"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform"
              />
            </div>
            
            <div className="p-6 space-y-3">
              <h3 className="text-xl font-bold text-gray-900" style={{ fontFamily: "'Noto Serif KR', serif" }}>
                프로듀서 크레딧
              </h3>
              <p className="text-2xl font-black text-amber-600">₩500,000</p>
              <p className="text-sm text-gray-600 leading-relaxed">
                엔딩 크레딧 프로듀서 등재 + 촬영장 방문 기회
              </p>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all border border-gray-200 group cursor-pointer">
            <div className="h-80 bg-gray-50 flex items-center justify-center p-8">
              <img
                src="https://readdy.ai/api/search-image?query=exclusive%20movie%20merchandise%20collection%20including%20t-shirt%20and%20cap%20with%20minimalist%20design%20on%20clean%20white%20background%20professional%20product%20photography%20with%20soft%20shadows&width=600&height=800&seq=reward004&orientation=portrait"
                alt="굿즈 패키지"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform"
              />
            </div>
            
            <div className="p-6 space-y-3">
              <h3 className="text-xl font-bold text-gray-900" style={{ fontFamily: "'Noto Serif KR', serif" }}>
                굿즈 패키지
              </h3>
              <p className="text-2xl font-black text-amber-600">₩30,000</p>
              <p className="text-sm text-gray-600 leading-relaxed">
                영화 티셔츠 + 포스터 + 스티커 세트
              </p>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all border border-gray-200 group cursor-pointer">
            <div className="h-80 bg-gray-50 flex items-center justify-center p-8">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20vip%20movie%20premiere%20invitation%20card%20with%20golden%20details%20on%20clean%20white%20background%20luxury%20event%20ticket%20design%20professional%20product%20photography&width=600&height=800&seq=reward005&orientation=portrait"
                alt="VIP 시사회"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform"
              />
            </div>
            
            <div className="p-6 space-y-3">
              <h3 className="text-xl font-bold text-gray-900" style={{ fontFamily: "'Noto Serif KR', serif" }}>
                VIP 시사회
              </h3>
              <p className="text-2xl font-black text-amber-600">₩100,000</p>
              <p className="text-sm text-gray-600 leading-relaxed">
                VIP 시사회 초대 + 배우 및 감독과의 만남
              </p>
            </div>
          </div>
          
          <div className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all border border-gray-200 group cursor-pointer">
            <div className="h-80 bg-gray-50 flex items-center justify-center p-8">
              <img
                src="https://readdy.ai/api/search-image?query=behind%20the%20scenes%20photo%20book%20with%20exclusive%20movie%20production%20images%20on%20clean%20white%20background%20premium%20photography%20album%20product%20shot%20with%20elegant%20presentation&width=600&height=800&seq=reward006&orientation=portrait"
                alt="메이킹 북"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform"
              />
            </div>
            
            <div className="p-6 space-y-3">
              <h3 className="text-xl font-bold text-gray-900" style={{ fontFamily: "'Noto Serif KR', serif" }}>
                메이킹 북
              </h3>
              <p className="text-2xl font-black text-amber-600">₩80,000</p>
              <p className="text-sm text-gray-600 leading-relaxed">
                촬영 현장 비하인드 포토북 + 배우 사인
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
